import { sanitizeUrl } from '@braintree/sanitize-url';
import { ApiUtil, UrlUtil } from '@everfi/reactifi';
import {
  AuthorizationRequest,
  AuthorizationServiceConfiguration,
  DefaultCrypto,
  FetchRequestor,
  LocalStorageBackend,
  RedirectRequestHandler,
} from '@openid/appauth';
import environment from '../environment';
import { NoHashQueryStringUtils } from './noHashQueryStringUtils';
const { getAuthApp } = environment;

const authenticate = async (slug, program_slug, authApp) => {
  const currentUrl = new URL(sanitizeUrl(window.location.href));
  const originalLoginDestination = currentUrl.href.replace(currentUrl.origin, '');
  localStorage.setItem('original-login-destination', originalLoginDestination);
  const currentRequestKey = localStorage.getItem('appauth_current_authorization_request');
  Object.keys(localStorage).forEach(key => {
    if (key.includes('appauth_authorization') && !key.includes(currentRequestKey)) {
      localStorage.removeItem(key);
    }
  });

  const extras = {};
  extras.redirect_path = originalLoginDestination;
  if (slug) {
    extras.foundry_slug = slug;
    if (program_slug) {
      extras.foundry_auth_type = 'guest_user';
      extras.program_slug = program_slug;
    }
  } else {
    extras.foundry_auth_type = 'admin';
  }

  const authorizationHandler = new RedirectRequestHandler(
    new LocalStorageBackend(),
    new NoHashQueryStringUtils(),
    window.location,
    new DefaultCrypto()
  );
  const response = await AuthorizationServiceConfiguration.fetchFromIssuer(authApp?.url, new FetchRequestor()); // OPENID_Configuration request well-known
  const authRequest = new AuthorizationRequest(
    {
      client_id: authApp?.clientId,
      extras,
      redirect_uri: authApp?.redirectUri,
      response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
      scope: 'openid email profile',
      state: undefined,
    },
    new DefaultCrypto()
  );
  authorizationHandler.performAuthorizationRequest(response, authRequest); // First authorize request sent
};

export const checkAuthenticated = async function checkAuthenticated(slug, program_slug, tokenStore, app) {
  const authApp = getAuthApp(app);
  let sessionAlive;
  let tokenValid;

  if (tokenStore.currentToken) {
    try {
      const tokenStatus = await ApiUtil.loadExternalData(
        `${authApp?.url}/oauth/token/info`,
        tokenStore.currentToken,
        false
      );
      tokenValid = tokenStatus.expires_in > 0;
      if (!tokenValid) {
        tokenStore.clearToken();
      }
      if (UrlUtil.getUrlDomain() === UrlUtil.getUrlDomain(authApp.url)) {
        const sessionStatus = await ApiUtil.loadApiData(`${authApp.url}/session_status`, false);
        sessionAlive = sessionStatus.alive;
      } else {
        // cross domain should only be local, assume session is alive
        sessionAlive = true;
      }
    } catch (e) {
      tokenValid = false;
      sessionAlive = false;
    }
  }
  const authenticated = !!tokenStore.currentToken && sessionAlive && tokenValid;

  if (!authenticated) {
    tokenStore.clearToken();
    await authenticate(slug, program_slug, authApp);
  }
  return authenticated;
};
